exports.songsdata = [
    {
        "id": 15,
        "title": "Halhatatlan jel",
        "album_title": "Túlzó láng",
        "album_url": `${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/rp_halhatatlan_jel_tulzo_lang.wav",
        "lyrics": "Hamarosan...",
        "length": "5:20"
    },
    {
        "id": 14,
        "title": "Titkos alagút",
        "album_title": "Túlzó láng",
        "album_url": `${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/rp_titkos_alagut_tulzo_lang.wav",
        "lyrics": "Hamarosan...",
        "length": "2:57"
    },
        {
        "id": 13,
        "title": "Reménytelen",
        "album_title": "Túlzó láng",
        "album_url": `${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/rp_remenyelen_tulzo_lang.wav",
        "lyrics": "Hamarosan...",
        "length": "4:18"
    },
    {
        "id": 12,
        "title": "Tűzhordozó",
        "album_title": "Túlzó láng",
        "album_url": `${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/album_borito_tulzo_lang.webp'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/rp_tuzhordozo_tulzo_lang.wav",
        "lyrics": "Hamarosan...",
        "length": "4:33"
    },
    {
        "id": 11,
        "title": "Szolgáló",
        "album_title": "Demó",
        "album_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/coverImages/szolgalo/szolgaloCover.jpg'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/coverImages/szolgalo/szolgaloCover.jpg'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/Red_Pumpkin_-_Szolgalo.wav",
        "lyrics": "",
        "length": "3:55"
    },
    {
        "id": 10,
        "title": "Belső háború",
        "album_title": "Demó",
        "album_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/coverImages/belsoHaboru/belsoHaboruCover.jpg'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/coverImages/belsoHaboru/belsoHaboruCover.jpg'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/Red_Pumpkin_-_Belso_haboru.wav",
        "lyrics": "",
        "length": "3:34"
    },
    {
        "id": 9,
        "title": "Fekete krónika",
        "album_title": "Demó",
        "album_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/coverImages/feketeKronika/feketeKronikaCover.jpg'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/coverImages/feketeKronika/feketeKronikaCover.jpg'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/Red_Pumpkin_-_Fekete_kronika.wav",
        "lyrics": "Szabadon vagy láncra verve, szemeid bezárva, a szivárvány íze mégis pokolian fájna. Fekete krónikában kék madárka, mennyi lehet a lélek ára, ha titokban van elém tárva?\n\n Fortuna kegyeibe fogadta az énem, mindent feláldoztam, hogy igazán éljek. Ízleltem gyümölcsét és féltem, a hetedik fejezet végleg ott hagy a révben.\r\n Minden holnapot a mára cseréltem, tébolyult lelkem szenved még most sem értem. Néha a vágy karmai könnyen elérnek, remélem feleszmélek időben és térben.",
        "length": "4:12"
    },
    {
        "id": 8,
        "title": "Halhatatlan jel",
        "album_title": "Demó",
        "album_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/coverImages/halhatatlanJel/halhatatlanJelCover.jpg'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/coverImages/halhatatlanJel/halhatatlanJelCover.jpg'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/Red_Pumpkin_-_Halhatatlan_jel.wav",
        "lyrics": "Hamarosan...",
        "length": "5:22"
    },
    {
        "id": 7,
        "title": "Bukott angyal",
        "album_title": "Demó",
        "album_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/coverImages/bukottAngyal/bukottAngyalCover.jpg'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/coverImages/bukottAngyal/bukottAngyalCover.jpg'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/Red_Pumpkin_-_Bukott_angyal.wav",
        "lyrics": "Hamarosan...",
        "length": "4:57"
    },
    {
        "id": 6,
        "title": "Időkerék",
        "album_title": "Demó",
        "album_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/Red_Pumpkin_-_Idokerek.wav",
        "lyrics": "Hamarosan...",
        "length": "4:05"
    },
    {
        "id": 5,
        "title": "Tűzhordozó",
        "album_title": "Demó",
        "album_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/Red_Pumpkin_-_Tuzhordozo.wav",
        "lyrics": "Hamarosan...",
        "length": "4:42"
    },
    {
        "id": 4,
        "title": "Hullócsillag",
        "album_title": "Demó",
        "album_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/Red_Pumpkin_-_Hullocsillag.wav",
        "lyrics": "Hamarosan...",
        "length": "4:11"
    },
    {
        "id": 3,
        "title": "Ígéret földje",
        "album_title": "Demó",
        "album_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/Red_Pumpkin_-_Igeret_foldje.wav",
        "lyrics": "Hamarosan...",
        "length": "4:55"
    },
    {
        "id": 2,
        "title": "Titkos alagút",
        "album_title": "Demó",
        "album_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/Red_Pumpkin_-_Titkos_alagut.wav",
        "lyrics": "Hamarosan...",
        "length": "3:02"
    },
    {
        "id": 1,
        "title": "Nem lehet baj",
        "album_title": "Demó",
        "album_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/Red_Pumpkin_-_Nem_Lehet_Baj.wav",
        "lyrics": "Hamarosan...",
        "length": "6:17"
    },
    {
        "id": 0,
        "title": "Reménytelen",
        "album_title": "Demó",
        "album_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "background_cover_url": `${process.env.PUBLIC_URL + '/albumBorito.webp'}`,
        "url": "https://red-pumpkin-songs.s3.eu-north-1.amazonaws.com/Red_Pumpkin_-_Remenytelen.wav",
        "lyrics": "Hamarosan...",
        "length": "4:00"
    }
]
